import { BaseParser } from './BaseParser';
import { IParseResult, ParseResult, ValueType } from '../FormatterTypes';
import {
  formatterStrParamDef,
  formatterParamParamFind2,
} from '../Utils/ParamUtils';
import { skipWhiteSpace, nextNumber } from '../Utils/StringUtils';
import * as R from 'ramda';

export class TEDParseGroupedNr extends BaseParser {
  public static getInstance(): TEDParseGroupedNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseGroupedNr;

  defaultParams(): string {
    return 'Groups="";DefaultGroup="";GroupTexts="";ValidGroupNameSeps=" ";ValidGroupSeps=" ,.";ValidDecimalSeps=""';
  }

  parse(text: string, params: string = ''): IParseResult {
    const decSep = ',';
    const defaultParams = this.defaultParams();
    const used: number[] = [];
    let val: number = 0;
    let value: ValueType = null;
    let result: ParseResult = ParseResult.OK;

    const decSeps = formatterStrParamDef(
      'ValidDecSeps',
      params,
      defaultParams
    ).split('');

    const groupNameSeps = R.difference(
      formatterStrParamDef('ValidGroupNameSeps', params, defaultParams).split(
        ''
      ),
      decSeps
    );

    const groupSeps = formatterStrParamDef(
      'ValidGroupSeps',
      params,
      defaultParams
    ).split('');

    const groupNameCharCodes = R.difference(
      R.difference(
        R.difference(
          R.range(33, 255),
          groupNameSeps.map(sep => sep.charCodeAt(0))
        ),
        groupSeps.map(sep => sep.charCodeAt(0))
      ),
      decSeps.map(sep => sep.charCodeAt(0))
    );

    let index = skipWhiteSpace(text, 0);
    const neg = text[index] === '-';

    if (['+', '-'].includes(text[index])) {
      index++;
    }
    do {
      index = skipWhiteSpace(text, index);
      const { num, newIndex } = nextNumber(
        text,
        index,
        decSeps,
        false,
        false,
        decSep
      );
      index = newIndex;
      let tmpNum = num;
      index = skipWhiteSpace(text, index);
      while (groupNameSeps.includes(text[index])) {
        index++;
      }

      index = skipWhiteSpace(text, index);
      let startOfGroupName = index;
      while (groupNameCharCodes.includes(text.charCodeAt(index))) {
        index++;
      }

      let tmpGroup = text.slice(startOfGroupName, index);
      const groupsTexts = formatterParamParamFind2(
        'GroupTexts',
        tmpGroup,
        params,
        defaultParams
      );
      if (tmpGroup === '') {
        tmpGroup = formatterStrParamDef('DefaultGroup', params, defaultParams);
      } else if (groupsTexts) {
        tmpGroup = groupsTexts.paramValue;
      }

      const tmpGroupValue = formatterParamParamFind2(
        'Groups',
        tmpGroup,
        params,
        defaultParams
      );
      if (tmpGroupValue) {
        let tmpVal = Number.parseFloat(tmpNum.replace(/,/g, '.'));
        let mult = Number.parseInt(
          tmpGroupValue.paramValue.replace(/,/g, '.'),
          10
        );
        if (
          !Number.isNaN(tmpVal) &&
          !Number.isNaN(mult) &&
          used.indexOf(mult) < 0
        ) {
          val = val + Math.round(tmpVal * mult);
          used.push(mult);
        } else {
          result = ParseResult.ERROR;
        }
      } else {
        result = ParseResult.ERROR;
      }
      index = skipWhiteSpace(text, index);
      while (index < text.length && groupSeps.includes(text[index])) {
        index++;
      }
      index = skipWhiteSpace(text, index);
    } while (result === ParseResult.OK && index < text.length);

    if (result === ParseResult.OK) {
      if (neg) {
        value = -val;
      } else {
        value = val;
      }
    }

    return {
      result,
      value,
    };
  }
}
